var CasePracticeProNavComponent = (function () {
    function CasePracticeProNavComponent() {
        this.steps = 3;
        this.currentSteps = 1;
        this.progress = 0;
        this.MaxProgress = [10, 20, 100];
        this.flag = false;
    }
    CasePracticeProNavComponent.prototype.ngOnInit = function () {
        this.flag = this.exerciseMetaId === 60701 || 60702 || 60703 || 131 || 141 || 151 ? true : false;
        this.stepList = [];
        for (var i = 1; i <= this.steps; i++) {
            this.stepList.push(i);
        }
    };
    CasePracticeProNavComponent.prototype.ngAfterViewInit = function () {
    };
    return CasePracticeProNavComponent;
}());
export { CasePracticeProNavComponent };



// WEBPACK FOOTER //
// ./src/app/case-practice-pro-nav/case-practice-pro-nav.component.ts.pre-build-optimizer.js